import { render, staticRenderFns } from "./meetObjectRelationXf.vue?vue&type=template&id=4a910a3e"
import script from "./meetObjectRelationXf.vue?vue&type=script&lang=js"
export * from "./meetObjectRelationXf.vue?vue&type=script&lang=js"
import style0 from "./meetObjectRelationXf.vue?vue&type=style&index=0&id=4a910a3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports